export {
	adaptAnalyticsWebClientForXpc,
	HelpCenterXpcNavigationObserver,
	type HelpCenterXpcNavigationObserverProps,
} from './xpc-navigation';
